import { RequestWebApi, validateRequestErrorStatus } from "./Requests";

const controller = "TipoDocs";

export const Listar = (filtros) =>
  RequestWebApi.get(`/${controller}/Listar`, { params: { ...filtros } })
    .then((response) => {
      const { resultData, success } = response.data;
      const tiposDocs = resultData || [];
      return { success, tiposDocs };
    })
    .catch((error) => {
      validateRequestErrorStatus(error?.response?.status);
      return { tiposDocs: [] };
    });

export const ListarSubTipoDocs = (filtros) =>
  RequestWebApi.get(`/${controller}/ListarSubTipoDocs`, { params: { ...filtros } })
    .then((response) => {
      const { resultData, success } = response.data;
      const subTiposDocs = resultData || [];
      return { success, subTiposDocs };
    })
    .catch((error) => {
      validateRequestErrorStatus(error?.response?.status);
      return { subTiposDocs: [] };
    });

export const Detalhes = (tipoDocsId) =>
  RequestWebApi.get(`/${controller}/Detalhes`, {
    params: { tipoDocsId },
  })
    .then((response) => {
      const { resultData, success } = response.data;
      const tipoDocs = resultData || {};
      return { success, tipoDocs };
    })
    .catch((error) => {
      validateRequestErrorStatus(error?.response?.status);
      const { success, message, errors } = error?.response?.data || {};
      return { success, message, errors, tipoDocs: {} };
    });

export const Incluir = (tipoDocs) =>
  RequestWebApi.post(`/${controller}/Incluir`, tipoDocs)
    .then((response) => {
      const { resultData, success } = response.data;
      const novoTipoDocs = resultData;
      return { success, novoTipoDocs };
    })
    .catch((error) => {
      validateRequestErrorStatus(error?.response?.status);
      const { success, message, errors } = error?.response?.data || {};
      return { success, message, errors };
    });

export const Atualizar = (tipoDocs) =>
  RequestWebApi.put(`/${controller}/Atualizar`, tipoDocs)
    .then((response) => {
      const { success } = response.data;
      return { success };
    })
    .catch((error) => {
      validateRequestErrorStatus(error?.response?.status);
      const { success, message, errors } = error?.response?.data || {};
      return { success, message, errors };
    });

export const Remover = (tipoDocsId) =>
  RequestWebApi.delete(`/${controller}/Remover`, {
    params: { tipoDocsId },
  })
    .then((response) => {
      const { success } = response.data;
      return { success };
    })
    .catch((error) => {
      validateRequestErrorStatus(error?.response?.status);
      const { success, message, errors } = error?.response?.data || {};
      return { success, message, errors };
    });
